export default "__VITE_ASSET__CFgOBuYW__"